import styled from "styled-components";

export const HeroContainer = styled.div`
  background: ${({ theme }) => theme.card_light};
  display: flex;
  justify-content: center;
  position: relative;
  padding: 80px 30px;
  @media (max-width: 960px) {
    padding: 40px 16px;
  }
  @media (max-width: 640px) {
    padding: 32px 12px;
  }
  z-index: 1;
`;

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  height: 100%;
  max-width: 1360px;
  overflow: hidden;
  padding: 0 30px;
  pointer-events: none;
  opacity: 0.6;
  @media (max-width: 960px) {
    justify-content: center;
    padding: 0;
  }
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;
  gap: 32px;
  @media (max-width: 960px) {
    flex-direction: column;
    max-width: 100vw;
    gap: 24px;
  }
  @media (max-width: 640px) {
    padding: 0 4px;
  }
`;

export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;
  @media (max-width: 960px) {
    order: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  max-width: 480px;
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  order: 2;
  @media (max-width: 960px) {
    order: 2;
    height: 300px;
    max-width: 360px;
  }
  @media (max-width: 640px) {
    height: 260px;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 46px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.25;
  margin-bottom: 8px;
  @media (max-width: 960px) {
    text-align: center;
    font-size: 36px;
  }
  @media (max-width: 640px) {
    font-size: 28px;
    line-height: 1.3;
  }
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: 28px;
  display: flex;
  gap: 10px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.4;
  margin-bottom: 16px;
  @media (max-width: 960px) {
    justify-content: center;
    font-size: 22px;
  }
  @media (max-width: 640px) {
    font-size: 18px;
    margin-bottom: 12px;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`;

export const SubTitle = styled.div`
  font-size: 17px;
  line-height: 1.6;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.text_secondary};
  max-width: 600px;
  @media (max-width: 960px) {
    text-align: center;
    font-size: 15px;
    margin-bottom: 24px;
  }
  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 1.5;
  }
`;

export const ResumeButton = styled.a`
  -webkit-appearance: button;
  -moz-appearance: button;
  appearance: button;
  text-decoration: none;
  width: 95%;
  max-width: 220px;
  text-align: center;
  padding: 14px 20px;
  color: ${({ theme }) => theme.white};
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease-in-out !important;
  background: linear-gradient(135deg, ${({ theme }) => theme.primary} 0%, #a855f7 100%);
  box-shadow: 0 4px 20px rgba(133, 76, 230, 0.35);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(133, 76, 230, 0.5);
    filter: brightness(1.05);
  }
  @media (max-width: 640px) {
    padding: 12px 16px;
    font-size: 15px;
    max-width: 100%;
  }
`;

export const SecondaryButton = styled.a`
  text-decoration: none;
  width: 95%;
  max-width: 220px;
  text-align: center;
  padding: 14px 20px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
  background: transparent;
  border: 1.5px solid ${({ theme }) => theme.primary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: ${({ theme }) => theme.primary + '18'};
    transform: translateY(-2px);
  }
  @media (max-width: 640px) {
    padding: 12px 16px;
    font-size: 15px;
    max-width: 100%;
  }
`;
